import * as React from "react"
import { Animate, AnimateGroup } from "react-simple-animate"
import { navigate } from "@reach/router"
import Bday from "./Bday"
// @ts-ignore
import video from "../images/react-hook-form-demo-video.mp4"
// @ts-ignore
import nativeVideo from "../images/react-hook-form-native-demo-video.mp4"
import home from "../data/home"
import { useStateMachine } from "little-state-machine"
import translateLink from "./logic/translateLink"
import typographyStyles from "../styles/typography.module.css"
import buttonStyles from "../styles/button.module.css"
import styles from "./Header.module.css"
import codeAreaStyles from "./CodeArea.module.css"
import generic from "../data/generic"
import copyClipBoard from "./utils/copyClipBoard"
import getStartedWithExamplesContent from "../data/getStartedWithExamples"
const getStartedEn = getStartedWithExamplesContent["en"]

const LogoSvg = (
  <>
    <path d="M73.56,13.32H58.14a8.54,8.54,0,0,0-16.27,0H26.44a11,11,0,0,0-11,11V81.63a11,11,0,0,0,11,11H73.56a11,11,0,0,0,11-11V24.32A11,11,0,0,0,73.56,13.32Zm-30.92,2a1,1,0,0,0,1-.79,6.54,6.54,0,0,1,12.78,0,1,1,0,0,0,1,.79h5.38v6.55a3,3,0,0,1-3,3H40.25a3,3,0,0,1-3-3V15.32ZM82.56,81.63a9,9,0,0,1-9,9H26.44a9,9,0,0,1-9-9V24.32a9,9,0,0,1,9-9h8.81v6.55a5,5,0,0,0,5,5h19.5a5,5,0,0,0,5-5V15.32h8.81a9,9,0,0,1,9,9Z" />
    <path
      style={{ transform: "translateX(-25px)" }}
      d="M71.6,45.92H54a1,1,0,0,0,0,2H71.6a1,1,0,0,0,0-2Z"
    />
    <path d="M71.6,45.92H54a1,1,0,0,0,0,2H71.6a1,1,0,0,0,0-2Z" />
    <path
      style={{ transform: "translateX(-25px)" }}
      d="M71.1,69.49H53.45a1,1,0,1,0,0,2H71.1a1,1,0,0,0,0-2Z"
    />
    <path d="M71.1,69.49H53.45a1,1,0,1,0,0,2H71.1a1,1,0,0,0,0-2Z" />
  </>
)

export default function Header({
  homeRef,
  defaultLang,
}: // isCardPlay,
{
  homeRef: React.Ref<HTMLDivElement>
  defaultLang: string
  // isCardPlay: boolean
}) {
  const [isWeb, setIsWeb] = React.useState(true)
  const {
    state: { language },
  } = useStateMachine()
  const {
    state
  } = useStateMachine()
  const { currentLanguage } =
    language && language.currentLanguage
      ? language
      : { currentLanguage: defaultLang }
  const lightMode = state?.setting?.lightMode
  const getStarted = getStartedWithExamplesContent[currentLanguage]

  return (
    <>
      <AnimateGroup play>
        <header className={styles.head} id="main">
          <Animate
            sequenceIndex={0}
            duration={0.2}
            start={{
              transform: "translateY(20px)",
              opacity: 0,
            }}
            end={{
              transform: "translateY(0)",
            }}
            easeType="ease-in"
            render={({ style }) => (
              <h1
                className={`${typographyStyles.heading} ${styles.logoHeading}`}
                style={style}
              >
                {getStarted.header.title}
              </h1>
            )}
          />

          <Animate
            sequenceIndex={1}
            start={{
              transform: "translateY(20px)",
              opacity: 0,
            }}
            end={{
              transform: "translateY(0)",
            }}
            easeType="ease-in"
            render={({ style }) => (
              <p
                className={typographyStyles.subHeading}
                style={{ marginBottom: 0, maxWidth: 660, ...style }}
              >
                {home.slogan[currentLanguage]}
              </p>
            )}
          />
          
        </header>
      </AnimateGroup>
      {/*<Bday isCardPlay={isCardPlay} />*/}
    </>
  )
}
